import { useColorMode, useColorModeValue } from '@/components/ui/color-mode'
import { Box, IconButton } from '@chakra-ui/react'
import { FiMoon, FiSun } from 'react-icons/fi'

/**
 * Theme Toggle Button
 * Modern switch between light and dark mode
 */
export function ThemeToggle({ ...props }) {
  const { toggleColorMode } = useColorMode()
  const Icon = useColorModeValue(FiMoon, FiSun)
  const label = useColorModeValue('Switch to dark mode', 'Switch to light mode')

  return (
    <IconButton
      aria-label={ label }
      onClick={ toggleColorMode }
      variant="ghost"
      size="md"
      borderRadius="md"
      transition="all 0.1s"
      { ...props }
    >
      <Box as={ Icon } boxSize="18px" />
    </IconButton>
  )
}

export default ThemeToggle
